import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { LogoEmblem } from "@/components/Logo";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  const inputCls = "w-full border-b border-gold/25 bg-transparent py-3 font-sans text-sm text-warmwhite outline-none placeholder:text-softgrey/40 focus:border-gold";

  return (
    <div className="flex min-h-screen items-center justify-center bg-obsidian px-6" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <div className="flex justify-center"><LogoEmblem size={90} /></div>
        <h1 className="mt-6 text-center font-serif text-3xl text-warmwhite">Goldstone Admin</h1>
        <p className="mt-2 text-center font-sans text-xs tracking-luxe uppercase text-gold">Sourcing Desk</p>

        <form onSubmit={submit} className="mt-10 space-y-6">
          <input type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} data-testid="admin-email" />
          <input type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} data-testid="admin-password" />
          {error && <p className="font-sans text-xs text-red-400" data-testid="admin-error">{error}</p>}
          <button type="submit" disabled={loading} className="w-full bg-gold py-3.5 font-sans text-sm font-medium text-obsidian transition-all hover:brightness-110 disabled:opacity-60" data-testid="admin-login-btn">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
